import { render, staticRenderFns } from "./UserProfileMattermost.vue?vue&type=template&id=821fa84a&"
import script from "./UserProfileMattermost.vue?vue&type=script&lang=js&"
export * from "./UserProfileMattermost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports